import React from 'react';

/**
 * DataOps Runs Help Content
 */
const RunsHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Pipeline Runs
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Monitor and manage your data pipeline executions. Track run status, investigate failures, and analyze performance metrics to ensure reliable data delivery.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Run History
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          View and filter pipeline executions:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Run list</span>: See all past and current pipeline executions</p>
          <p>&#8226; <span className="font-medium">Status filters</span>: Filter by success, failure, running, or queued</p>
          <p>&#8226; <span className="font-medium">Time range</span>: View runs from specific time periods</p>
          <p>&#8226; <span className="font-medium">Pipeline filter</span>: Focus on specific pipelines or sources</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Status Tracking
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium text-green-600 dark:text-green-400">Success</span>: Pipeline completed without errors</p>
          <p>&#8226; <span className="font-medium text-red-600 dark:text-red-400">Failed</span>: Pipeline encountered an error and stopped</p>
          <p>&#8226; <span className="font-medium text-blue-600 dark:text-blue-400">Running</span>: Pipeline is currently executing</p>
          <p>&#8226; <span className="font-medium text-yellow-600 dark:text-yellow-400">Queued</span>: Pipeline is waiting to start</p>
          <p>&#8226; <span className="font-medium text-gray-600 dark:text-gray-400">Cancelled</span>: Pipeline was manually stopped</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Run Details
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Click any run to view detailed information:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Execution timeline</span>: See step-by-step progress</p>
          <p>&#8226; <span className="font-medium">Duration metrics</span>: Track execution time per step</p>
          <p>&#8226; <span className="font-medium">Error logs</span>: Investigate failure details and stack traces</p>
          <p>&#8226; <span className="font-medium">Data metrics</span>: View rows processed, data volume, etc.</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Performance Metrics
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Average duration</span>: Track typical execution times</p>
          <p>&#8226; <span className="font-medium">Success rate</span>: Monitor reliability over time</p>
          <p>&#8226; <span className="font-medium">Resource usage</span>: View CPU, memory, and I/O consumption</p>
          <p>&#8226; <span className="font-medium">Trends</span>: Identify performance degradation early</p>
        </div>
      </div>

    </>
  );
};

export default RunsHelp;
